import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { layoutStyle } from "../../pages/layout-ui/style";
import { useModel, useNewVehicle, useYear } from "../../common/hooks";
import { DISPLAY_MESSAGES } from "../../common/constants/popupMessage";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";

export const ReplaceExistingVehicle = ({
  open,
  selectedRowData,
  companyId,
  dealerId,
  setOpen,
  fleetList,
  setSelectedRows,
}) => {
  const classes = layoutStyle();
  const { multipleNewVehicleApi } = useNewVehicle();
  const { year, getYearApi } = useYear();
  const { modelData, modelLoading, getModelList } = useModel();

  useEffect(() => {
    getYearApi();
    getModelList();
  }, []);

  const handleClick = async () => {
    const currentYear = new Date().getFullYear();
    const yearId = year?.filter((item) => item.year === currentYear);
    let yearDataValue;
    if (yearId?.length > 0) {
      yearDataValue = yearId[0]?.id;
    }

    // For each selected row, replace New Vehicle Make/Model with the row's existing Make/Model.
    // Also look up the MPG from modelData for the matching year + makeId + model combination.
    const extractedData = selectedRowData.map((data) => {
      // Find a matching entry in modelData for the current year, same make, and same model name
      const matchedModel = modelData?.find(
        (item) =>
          item.yearId === yearDataValue &&
          item.makeId === data.makeId &&
          item.model === data.model
      );

      return {
        id: data.id,
        makeId: data.makeId,               // New Vehicle Make ← existing Make
        modelId: data.modelId,             // New Vehicle Model ← existing Model
        yearId: data.newYearId,              // Keep existing year unchanged
        mpg: matchedModel?.mpg ?? data.newMpg ?? data.mpg,
        fuelId: data.fuelId,
      };
    });

    const finalPayload = {
      updateIds: extractedData,
      companyId: companyId,
      dealerId: dealerId,
    };

    await multipleNewVehicleApi({ values: finalPayload });
    setOpen(false);
    setSelectedRows([]);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {DISPLAY_MESSAGES.REPLACE_EXISTING_VEHICLE}
        </DialogTitle>
        <DialogActions>
          <Button
            variant="outlined"
            type="submit"
            className={classes.deleteCancelButton}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          {modelLoading ? (
            <span>
              <CircularProgress
                color="inherit"
                className={classes.fetchingMakeModel}
              />
            </span>
          ) : (
            <Button
              variant="outlined"
              type="submit"
              className={classes.deleteOkButton}
              onClick={handleClick}
            >
              Yes
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
